import { Link } from 'react-router';

export default function DatenschutzPage() {
  return (
    <main className="min-h-screen bg-warm-50 px-6 py-16 lg:px-8">
      <div className="mx-auto max-w-3xl rounded-2xl border border-warm-200/60 bg-white p-8 lg:p-10 shadow-[0_10px_28px_-16px_rgba(26,24,22,0.18)]">
        <h1 className="text-3xl font-semibold tracking-tight text-warm-800 mb-4">Datenschutz</h1>
        <p className="text-warm-600 leading-relaxed mb-6">
          MediFlow verarbeitet Daten DSGVO-konform mit technischen und organisatorischen Schutzmaßnahmen,
          inklusive Verschlüsselung, Zugriffskontrolle und Audit-Trail.
        </p>
        <section id="technische-und-organisatorische-massnahmen" className="mb-6 scroll-mt-24">
          <h2 className="text-xl font-semibold text-warm-800 mb-2">Technische und organisatorische Massnahmen</h2>
          <p className="text-warm-600 leading-relaxed">
            Zugriffsschutz, rollenbasierte Berechtigungen, Audit-Trail und dokumentierte Betriebsprozesse
            bilden die oeffentliche Datenschutz- und Compliance-Basis fuer die Landing-Claims.
          </p>
        </section>
        <section id="verschluesselung-und-zugriffsschutz" className="mb-6 scroll-mt-24">
          <h2 className="text-xl font-semibold text-warm-800 mb-2">Verschluesselung und Zugriffsschutz</h2>
          <p className="text-warm-600 leading-relaxed">
            Datenuebertragung und Speicherung sind verschluesselt. Zugriffe werden nachvollziehbar protokolliert,
            damit Datenschutzanfragen und interne Pruefungen auf eine klar benennbare Schutzflaeche verweisen koennen.
          </p>
        </section>
        <section id="hosting-und-speicherort" className="mb-6 scroll-mt-24">
          <h2 className="text-xl font-semibold text-warm-800 mb-2">Hosting und Speicherort</h2>
          <p className="text-warm-600 leading-relaxed">
            Das Landing-Material verweist auf deutsches Hosting. Diese Seite dient als oeffentliche Einordnung fuer
            Speicherort, Betriebsmodell und die Ansprechwege fuer weitergehende Unterlagen.
          </p>
        </section>
        <a href="mailto:datenschutz@getflowly.de?subject=Datenschutzanfrage" className="landing-cta-primary mr-3">Datenschutzanfrage senden</a>
        <Link to="/" className="landing-cta-secondary">Zur Landing Page</Link>
      </div>
    </main>
  );
}
